module.exports = __webpack_public_path__ + "img/2_3_2.63ab2bec.png";